import { DcBaseComponent } from '@deleteagency/dc';
import { eventBus, events } from '../../../general/js/events';

export default class SearchResultGalleryComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-result-gallery';
    }

    onInit() {
        this.preloadImages = 1;
        this.initInitialSliders();

        eventBus.addListener(events.ADDITIONAL_SLIDERS_LOADED_EVENT, () => {
            this.initInitialSliders();
        });
    }

    initInitialSliders() {
        const sliderContainers = document.querySelectorAll('.search-result-property');

        if (sliderContainers.length > 0) {
            sliderContainers.forEach(container => {
                this.initSlider(container);
            });
        }
    }

    initSlider(container) {
        const mainSlider = container.querySelector('.property-carousel--main');
        const navThumbs = container.querySelector('.property-carousel--navigation');
        const slideCounter = container.querySelector('.property-carousel--slider-counter');
        let slider = null;

        if (!mainSlider) {
            return;
        }

        if (!mainSlider.classList.contains('initialized-slider')) {
            slider = new KeenSlider(mainSlider, {
                initial: 0,
                loop: true,
                spacing: 0,
                controls: true,
                slideChanged: (instance) => {
                    this.updateSlideCounter(slider, slideCounter);
                    this.updateThumbnails(instance, navThumbs);
                    this.setSliderImages(instance, mainSlider);
                },
                created: (instance) => {
                    this.updateThumbnails(instance, navThumbs);
                    this.setSliderImages(instance, mainSlider);
                    this.updateSlideCounter(instance, slideCounter);
                    this.addArrowNavigation(instance, mainSlider);
                    mainSlider.classList.add('initialized-slider');
                },
            });
        }
    }
    
    setSliderImages(slider, container) {
        const slides = container.querySelectorAll('.keen-slider__slide');
        const totalSlides = slides.length;
        
        for (let i = 0; i < Math.min(this.preloadImages, totalSlides); i++) {
            const img = slides[i].querySelector('img');
            if (!img.getAttribute('src')) {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.setAttribute('srcset', img.getAttribute('data-srcset'));
            }
        }
    }

    updateThumbnails(slider, navThumbs) {
        const images = navThumbs.querySelectorAll('img');
        const totalSlides = slider.slides.length;
        let currentSlide = slider.track.details.abs % totalSlides;
        let nextSlide = (currentSlide + 1) % totalSlides;
        let nextNextSlide = (currentSlide + 2) % totalSlides;
        
        if (nextSlide < 0) nextSlide += totalSlides;
        if (nextNextSlide < 0) nextNextSlide += totalSlides;
        
        this.preloadNextImages(slider, currentSlide, totalSlides);
        
        if (window.innerWidth <= 1024) return;
        
        images.forEach(img => img.classList.remove('loaded'));

        setTimeout(() => {
            images[0].classList.add('fade');
            images[1].classList.add('fade');
            setTimeout(() => {
                images[0].setAttribute('src', slider.slides[nextSlide].querySelector('img').getAttribute('data-thumbnail'));
                images[0].classList.add('loaded');
            }, 150);
            setTimeout(() => {
                images[1].setAttribute('src', slider.slides[nextNextSlide].querySelector('img').getAttribute('data-thumbnail'));
                images[1].classList.add('loaded');
            }, 300);
        }, 10);        
    }

    preloadNextImages(slider, currentSlide, totalSlides) {
        const slides = slider.slides;
        
        for (let i = -this.preloadImages; i <= this.preloadImages; i++) {
            let nextSlideIndex = (currentSlide + i + totalSlides) % totalSlides;
            let img = slides[nextSlideIndex].querySelector('img');
            
            if (!img.getAttribute('src')) {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.setAttribute('srcset', img.getAttribute('data-srcset'));
            }
        }

    }
    updateSlideCounter(slider, counterElement) {
        let currentSlide = (slider.track.details.abs % slider.slides.length + slider.slides.length) % slider.slides.length + 1;
        const totalSlides = slider.slides.length;
        counterElement.textContent = `${currentSlide}/${totalSlides}`;
    }

    addArrowNavigation(sliderInstance, container) {
        const existingArrows = container.querySelectorAll('.arrow');
        existingArrows.forEach(arrow => arrow.remove());

        const arrowLeft = document.createElement('button');
        arrowLeft.innerText = '<';
        arrowLeft.classList.add('arrow', 'arrow--left');
        arrowLeft.addEventListener('click', () => sliderInstance.prev());

        const arrowRight = document.createElement('button');
        arrowRight.innerText = '>';
        arrowRight.classList.add('arrow', 'arrow--right');
        arrowRight.addEventListener('click', () => sliderInstance.next());

        container.appendChild(arrowLeft);
        container.appendChild(arrowRight);
    }
}
